module.exports = __webpack_public_path__ + "media/components/country-flag/static/tt-ad3e2782246b2d74adb836c79405b62f.svg";